export const CONTACT_SUPPORT_ERROR_TEXT =
    'Please try again. If the problem persists, you can contact our Customer Support team via livechat or email.';

/**
 * Adds the standard contact support error text to the end of the message. Make sure the message ends in a full stop.
 */
export const getErrorMessageForToast = (message: string) => {
    return `${message} ${CONTACT_SUPPORT_ERROR_TEXT}`;
};
